function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 9.09524C8.75 7.38579 10.2051 6 12 6C13.7949 6 15.25 7.38579 15.25 9.09524C15.25 10.4773 14.2988 11.6479 12.9859 12.0455C12.4574 12.2056 12 12.6382 12 13.1905V14.6667",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 17.9167,
  r: 0.9,
  fill: "#627080"
});

const SvgHint = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Hint.3deda414.svg";
export { ForwardRef as ReactComponent };